export default __webpack_public_path__ + "static/media/logo_mapy.bc8388ed.svg";